import React from 'react';
import styled from 'styled-components';

const DashboardWrapper = styled.div`
  padding: 20px;
`;

const Title = styled.h1`
  color: #333;
`;

const Dashboard: React.FC = () => {
  return (
    <DashboardWrapper>
      <Title>Admin Dashboard</Title>
      <p>Welcome to your admin dashboard. Here you can manage users, jargon, and settings.</p>
      <p>
        <a href="users/">Manage Users</a>
        <br/><a href="jargons/">Jargons</a><br/>
        <a href="styles/">Styles</a>
      </p>
    </DashboardWrapper>
  );
}

export default Dashboard;